import {t} from 'i18next';

import {Box, Typography} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {ReactElement, useEffect, useMemo, useState} from 'react';
import AurBreadcrumb from '../../common/aur-breadcrumb/AurBreadCrumb';
import {RootState} from '../../../redux/store';
import {ReactComponent as BackgroundBlur} from '../../../assests/svg/backgroundBlur.svg';
import {SavedSearchType} from '../../eca/ECASavedSearchSidePanelDrawer';
import {EciHomePageTabs, MIN_SEARCH_CHAR} from '../../../constants/constants';
import AurSearchBox from '../../common/aur-search-box/AurSearchBox';
import SavedSearchesTemplatePanel from './components/SavedSearchesTemplatePanel';
import {setClientId} from '../../../redux/slices/savedSearchesTemplateSlice';
import {useLocation} from 'react-router-dom';

const ManageSavedSearchesTemplate: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const selectedClientId = useSelector(
    (state: RootState) => state.savedSearchesTemplate.clientId
  );

  const selectedIndex = 'Standard Index';
  const [selectedSearchDetailUI, setSelectedSearchDetailUI] =
    useState<ReactElement | null>(null);
  const [, setSelectedSavedSearch] = useState<SavedSearchType | null>(null);
  const [searchInput, setSearchInput] = useState<string>('');

  useEffect(() => {
    return () => {
      dispatch(setClientId(''));
    };
  }, []);

  const breadCrumbItems = useMemo(() => {
    const baseItems: {label: string; path?: string; onClick?: () => void}[] =
      location?.state?.from === 'core_eci'
        ? [
            {
              label: t('eca.ecaHomepage.coreEciHome'),
              path: `/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`,
            },
            {
              label: t('savedSearchesTemplate.manageSavedSearchesTemplate'),
            },
          ]
        : location?.state?.from === 'manage-dropdown'
          ? [
              {
                label: t('reports.projectOverview.label'),
                path: '/welcome-single-client',
              },
              {
                label: t('savedSearchesTemplate.manageSavedSearchesTemplate'),
              },
            ]
          : [
              {
                label: t('clientDetailsPage.clientDetails'),
                path: '/clients/details',
              },
              {
                label: t('savedSearchesTemplate.manageSavedSearchesTemplate'),
              },
            ];
    return baseItems;
  }, [location?.state?.from]);

  const renderHeader = useMemo(() => {
    return (
      <Typography
        tabIndex={0}
        className="typo-text display3_size overlay-title"
        data-testid="manage-overlay"
      >
        {t('savedSearchesTemplate.manageSavedSearchesTemplate')}
      </Typography>
    );
  }, []);

  return (
    <div className="saved-searches-template-management-container">
      <Box className="saved-searches-template-background-image">
        <BackgroundBlur aria-hidden="true" />
      </Box>

      <div className="overlay-layout">
        <Box
          className="breadcrumb-section overlay-breadcrumb"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <AurBreadcrumb items={breadCrumbItems} />
        </Box>

        <Box display={'flex'} justifyContent={'space-between'}>
          {renderHeader}
        </Box>
      </div>

      <Box className="saved-searches-template-container">
        <AurSearchBox
          label={t('fieldManagement.fieldTable.search')}
          parentClassName="search-field-input-div"
          classNameProps="text-field"
          minCharForSearch={MIN_SEARCH_CHAR}
          onSearch={setSearchInput}
          dataTestId="search-input"
        />
        <div className="saved-search-side-panel-drawer index-saved-search">
          <div className="content-container">
            <div className="panel-container panel-container-min-height">
              <div className="left-search-list-tree">
                <Box className="location-container">
                  {' '}
                  <Typography className="typo-text label2_size location-label">
                    {t('ecaDocList.saveSearch.location')}
                  </Typography>{' '}
                </Box>
                <SavedSearchesTemplatePanel
                  selectedIndex={selectedIndex}
                  enableFlayout={false}
                  renderSelectedSearchDetail={setSelectedSearchDetailUI}
                  onPickSavedSearch={setSelectedSavedSearch}
                  openForPickSavedSearch={false}
                  enableSearch={false}
                  searchInput={searchInput}
                  folderDetailsView={true}
                  showActions={true}
                  manageSaved={true}
                  manageSearchRename={true}
                  clientId={selectedClientId}
                />
              </div>
              <div className="right-search-detail">
                {selectedSearchDetailUI ?? null}
              </div>
            </div>
          </div>
        </div>
      </Box>
    </div>
  );
};

export default ManageSavedSearchesTemplate;
